export const INTERFACE_BASE_ROUTE = '/interfaces';
export const CUSTOM_COMPONENT_BASE_ROUTE = `${INTERFACE_BASE_ROUTE}/custom-components`;
export const MANAGER_BASE_ROUTE = `${INTERFACE_BASE_ROUTE}/manager`;
export const FORMS_BASE_ROUTE = `${INTERFACE_BASE_ROUTE}/forms`;
export const FIELDS_BASE_ROUTE = `${INTERFACE_BASE_ROUTE}/fields`;
